<template>
  <section v-if="open" class="modal">
    <div class="box box-flex">
      <div class="header">
        <div class="title">Bem-vindo a Swiss Money</div>
        <div @click="open = false" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="notification-img">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256">
          <defs>
            <linearGradient id="gradient-not" x1="43.03" y1="61.68" x2="167.03" y2="207.68" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#560070"/>
              <stop offset="1" stop-color="#8900b3"/>
            </linearGradient>
          </defs>
          <path d="M50.26,120c0,12,0,24,0,36C50.3,166,56,171.77,66,171.88c4.33.05,8.67.23,13,0,3.73-.25,5.3.66,5.08,4.84-.38,7.14-.1,14.32-.11,21.48,0,2.51-.28,5.19,2.44,6.59s5.06-.17,7.28-1.77c13.1-9.45,26.27-18.79,39.3-28.34a13.51,13.51,0,0,1,8.73-2.79c11.16.15,22.32.1,33.49,0,9.64-.06,15-5.53,15.17-15.26.06-4.83,0-9.66,0-14.49,0-3.2,1.15-5.77,4.75-5.76s4.79,2.42,4.77,5.71c0,5.5.16,11,0,16.5a23.23,23.23,0,0,1-22.93,22.49c-10.83.17-21.66.13-32.49,0a12.11,12.11,0,0,0-7.81,2.44C124,192.73,111.14,201.72,98.51,211c-5.15,3.77-10.46,5.18-16.29,2.18-5.63-2.9-7.81-7.85-7.58-14.06.12-3.33,0-6.66,0-10,0-8,0-7.93-7.74-8a35.42,35.42,0,0,1-7.44-.54A22.78,22.78,0,0,1,41.11,158c-.17-25.49-.22-51,0-76.46.12-13.4,10.25-23.25,23.64-23.36,17.16-.15,34.32,0,51.48-.07,3.54,0,6.67.72,6.6,4.9s-3.52,4.64-6.87,4.64c-16.49,0-33,0-49.48,0C55.59,67.68,50.28,73,50.26,84Q50.23,102,50.26,120Z" style="fill:url(#gradient-not)"/>
          <path d="M171.6,39.58a46.77,46.77,0,1,0,46.82,46.93A46.58,46.58,0,0,0,171.6,39.58Zm-.28,84.25a37.5,37.5,0,1,1,37.84-37.14A37.53,37.53,0,0,1,171.32,123.83Z" style="fill:url(#gradient-not)"/>
          <path class="notification-img-anim" d="M171.69,108a5.62,5.62,0,0,0,5.62-5.62H166.06A5.63,5.63,0,0,0,171.69,108Zm18.93-13.16c-1.7-1.82-4.88-4.57-4.88-13.56A13.89,13.89,0,0,0,174.5,67.64V65.81a2.81,2.81,0,0,0-5.62,0v1.83a13.89,13.89,0,0,0-11.25,13.64c0,9-3.18,11.74-4.87,13.56a2.73,2.73,0,0,0-.76,1.91,2.81,2.81,0,0,0,2.82,2.81h33.73a2.81,2.81,0,0,0,2.82-2.81A2.76,2.76,0,0,0,190.62,94.84Z" style="fill:url(#gradient-not)"/>
        </svg>
      </div>
      <div class="notification-text">
        Que tal receber alertas sobre novos eventos e ingressos?
      </div>
      <form @submit.prevent class="form">
        <button @click="subscribe" type="button" class="button-save" style="margin-top: 25px">
          <i class="fas fa-check"></i><span>Adoraria</span>
        </button>
        <div @click="open = false" class="notification-exit">Não, obrigado</div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
// import logger from '../../logger'
// import { savePlayerId } from '../api/auth'
// import { get as getCustomer } from '../api/customer'

export default {
  name: 'subscription',
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    user (newValue, oldValue) {
      /*
      if (newValue) {
        try {
          // CORDOVA
          if (process.env.CORDOVA_PLATFORM) {
            document.addEventListener('deviceready', () => {
              // window.plugins.OneSignal.provideUserConsent(true)
              window.plugins.OneSignal.getPermissionSubscriptionState((status) => {
                if (!status.subscriptionStatus.subscribed) {
                  this.open = true
                  window.plugins.OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
                    // window.plugins.OneSignal.setSubscription(accepted)
                  })
                }
              })
            }, false)
          // WEB
          } else {
            setTimeout(async () => {
              const pushEnabled = window.OneSignal ? await window.OneSignal.isPushNotificationsEnabled() : null
              if (!pushEnabled) this.open = true
            }, 5000)
          }
        } catch (error) {
          logger.error(error, this)
        }
      }
      */
    }
  },
  methods: {
    subscribe () {
      /*
      // CORDOVA
      if (process.env.CORDOVA_PLATFORM) {
        window.plugins.OneSignal.addSubscriptionObserver(async (state) => {
          if (!state.from.subscribed && state.to.subscribed) {
            window.plugins.OneSignal.promptLocation()
            // Send tags of user
            if (this.user && this.user.role === 'user') {
              const customer = await getCustomer()
              await savePlayerId(state.to.userId)
              window.plugins.OneSignal.setExternalUserId(customer.userId)
              window.plugins.OneSignal.sendTags({
                user_id: customer.userId,
                user_type: 'user',
                real_name: customer.name,
                first_name: customer.name.split(' ')[0]
              })
              window.plugins.OneSignal.setEmail(customer.login)
            }
          }
          this.open = false
        })
        window.plugins.OneSignal.setSubscription(false)
        window.plugins.OneSignal.setSubscription(true)
      // WEB
      } else {
        window.OneSignal.on('subscriptionChange', async (isSubscribed) => {
          try {
            // Get location (send tags)
            if (isSubscribed && navigator.geolocation) {
              navigator.geolocation.getCurrentPosition((position) => {
                window.OneSignal.push(() => {
                  window.OneSignal.sendTags({
                    latitude: position.coords.latitude,
                    long: position.coords.longitude
                  })
                })
              }, (error) => logger.warn(error))
            }
            // Send tags of user
            if (this.user && this.user.role === 'user') {
              const playerId = await window.OneSignal.getUserId()
              const customer = await getCustomer()
              await savePlayerId(playerId)
              window.OneSignal.setExternalUserId(customer.userId)
              window.OneSignal.push(() => {
                window.OneSignal.sendTags({
                  user_id: customer.userId,
                  user_type: 'user',
                  real_name: customer.name,
                  first_name: customer.name.split(' ')[0]
                })
              })
              window.OneSignal.setEmail(customer.login)
            }
          } catch (error) {
            logger.error(error, this)
          }
          this.open = false
        })
        window.OneSignal.registerForPushNotifications()
      }
      */
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.box-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.notification-img {
  height: auto;
  margin: 0 auto;
  svg {
    width: 200px;
    height: 200px;
  }
}

.notification-img-anim {
  transform-origin: center center;
  animation-name: notification;
  animation-timing-function: linear;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes notification {
  5% { transform: translate(-5px, 0) }
  10% { transform: translate(5px, 0) }
  15% { transform: translate(-5px, 0) }
  20% { transform: translate(0, 0) }
}

.notification-text {
  font-size: 1.4em;
  text-align: center;
  color: #333;
  padding: 0 15px;
}

.notification-exit {
  font-size: 1em;
  text-align: center;
  padding: 10px 15px;
  margin-top: 10px;
  border-radius: 100px;
  color: #777;
  cursor: pointer;
  &:hover {
    color: #555;
    background-color: $hover-color-2;
  }
}
</style>
